import { Injectable } from '@angular/core';
import * as routeSelectors from "../state/route/route.selector";
import {Store} from "@ngrx/store";
import {cameraActions} from "../state/camera/camera.actions";
import {Vector2, Vector3} from "three";
import {ActivatedRoute, Router} from "@angular/router";
import {selectWorldReady} from "../state/world/world.selector";
import {interfaceActions} from "../state/interface/interface.actions";
import {Entity} from "../state/entities/entity.model";
import {selectCameraTarget} from "../state/camera/camera.selector";
import {settings} from "../settings/settings";
import {share} from "rxjs";
import {UsersService} from "./users.service";

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  coordTo: Vector3
  isWorldReady = false
  cameraTarget = new Vector3(0, 0, 0)

  constructor(
      private store: Store,
      private router: Router,
      private route: ActivatedRoute,
      private userService: UsersService
  ) {
    this.store
        .select(routeSelectors.selectQueryParams)
        .subscribe((params) => {
          if (!params) return
          if (params["coord"]) {
            const coord = params["coord"]
            const [x, y, z] = coord.split(":").map(Number)
            this.coordTo = new Vector3(x, y, z)
            this.navigate()
          }
        })
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.cameraTarget = target
    })
    this.store.select(selectWorldReady).subscribe((isReady) => {
      if (isReady) {
        this.isWorldReady = true
        this.navigate()
      }
    })
  }

  navigate() {
    if (!this.isWorldReady) return
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        ['coord']: null // Setting to null removes the parameter
      },
      queryParamsHandling: 'merge' // Keeps all other parameters
    });
    this.store.dispatch(cameraActions.targetJumped({
      target: this.coordTo,
      jumpTimeMs: 250,
      skipCheckpoint: true
    }))
  }

  async shareEntity(entity: Entity, objectTypeDisplay: string, pointerPositiion?:Vector2) {
    const coord = Math.trunc(entity.coord.x) + ":" + Math.trunc(entity.coord.y-2) + ":" + Math.trunc(this.cameraTarget.z)
    const owner = await this.userService.getUser(entity.ownerId)
    const link = settings.appBaseUrl + "?coord="+coord
    const title = `${owner.display_name} on Binst`
    const textContent = entity.componentProperties.Text.slice(0, 25) ?? `View ${owner.display_name}'s post`
    await navigator.share({
        title: title,
        url: link
    })
  //   this.store.dispatch(interfaceActions.openContextMenu())
  //   this.router.navigate(
  //       [{outlets: {'context-menu': "context-share"}}],
  //       {
  //         queryParams: {
  //           shareType: objectTypeDisplay,
  //           shareCoord: coord,
  //           shareEntityId: entity.id,
  //           posX: pointerPositiion?.x - 100 ?? 500,
  //           posY: pointerPositiion?.y ?? 500
  //         },
  //         queryParamsHandling: 'merge' // optional but common
  //       })
  }
}
